module.exports = __webpack_public_path__ + "img/img37.e3ed27b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img37.jpg
// module id = 335
// module chunks = 0